import React from 'react'
import ReactDOM from 'react-dom'

import { ApolloProvider } from 'react-apollo'
import { BrowserRouter as Router } from 'react-router-dom'

import apolloClient from './modules/bootstrap/apolloClient'
import RootPage from './components/pages/RootPage'
// import registerServiceWorker from './registerServiceWorker'

import './styles/scss-style.css'

ReactDOM.render(
  <ApolloProvider client={apolloClient}>
    <Router>
      <RootPage />
    </Router>
  </ApolloProvider>,
  document.getElementById('root'),
)
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js